import { Component, OnInit, ElementRef, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from '../../../services/auth.service';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-notification-bell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.css']
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  showNotifications = false;
  hasNotifications = false;
  hoveredIndex = -1;
  notifications: Array<{
    id?: string;
    type: string;
    title: string;
    body: string;
    read: boolean;
    timestamp?: any;
  }> = [];

  private destroy$ = new Subject<void>();

  @ViewChild('notificationDropdown') notificationDropdown!: ElementRef;

  constructor(
    private afs: AngularFirestore,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.userAuth
      .pipe(takeUntil(this.destroy$))
      .subscribe((userAuth: any) => {
        const uid = userAuth?.uid;
        if (uid) {
          this.afs.collection('user-notifications').doc(uid)
            .collection('notifications', ref => ref
              .where('read', '==', false)
              .orderBy('timestamp', 'desc')
              .limit(10) // Limitamos a 10 para carga perezosa básica
            )
            .snapshotChanges()
            .pipe(
              takeUntil(this.destroy$),
              map(actions => actions.map(a => {
                const data: any = a.payload.doc.data();
                const id = a.payload.doc.id;
                return { id, ...data };
              }))
            )
            .subscribe((notifs: any[]) => {
              this.notifications = notifs;
              this.hasNotifications = this.notifications.length > 0;
            });
        } else {
          this.notifications = [];
          this.hasNotifications = false;
        }
      });
  }

  toggleDropdown(): void {
    this.showNotifications = !this.showNotifications;
  }

  trackById(index: number, item: any): string {
    return item.id;
  }

  markAsRead(index: number) {
    const notif = this.notifications[index];
    if (notif && notif.id) {
      const userAuth = this.authService.userAuth.getValue();
      const uid = userAuth?.uid;
      if (uid) {
        this.afs.collection('user-notifications').doc(uid)
          .collection('notifications')
          .doc(notif.id)
          .update({ read: true });
      }
    }
  }

  markAllAsRead(event: any) {
    const userAuth = this.authService.userAuth.getValue();
    const uid = userAuth?.uid;
    if (uid) {
      this.notifications.forEach(n => {
        if (n.id) {
          this.afs.collection('user-notifications').doc(uid)
            .collection('notifications')
            .doc(n.id)
            .update({ read: true });
        }
      });
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInsideDropdown = this.notificationDropdown?.nativeElement?.contains(event.target);
    const clickedOnBell = (event.target as HTMLElement).closest('.notification-bell');

    if (!clickedInsideDropdown && !clickedOnBell) {
      this.showNotifications = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
